import type { Subscription } from '../endpoints/storeApi.types';

export const getStripeSubscription = (response: Subscription) => {
  return response?.type === 'stripe' ? response : null;
};
